var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter}},[_c('div',{class:[_vm.animatedNumberClass, _vm.customClass]},[_vm._v("\n    "+_vm._s(_vm.formatNumber(_vm.animatedValue))+_vm._s(_vm.suffix)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-579592ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimatedNumber.vue
// module id = null
// module chunks = 